import { render, staticRenderFns } from "./safeProducts.vue?vue&type=template&id=802ef474"
import script from "./safeProducts.vue?vue&type=script&lang=js"
export * from "./safeProducts.vue?vue&type=script&lang=js"
import style0 from "./safeProducts.vue?vue&type=style&index=0&id=802ef474&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports